import Vue from 'vue'
import { app, data } from '@/categories/config/selectors'
import { getJsonData } from '@/common/utils/dom'
import { formatCurrencyJP } from '@/common/filter'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'

import { store } from '@/categories/store'
import App from '@/categories/App.vue'
import Categories from '@/categories/all/App.vue'
import SearchFilterCtrl from '@/categories/components/SearchFilterCtrl.vue'
import FacetsLink from '@/common/components/facets/FacetsLink.vue'
import SidebarApp from '@/categories/SidebarApp.vue'
import SortedProductSection from '@/categories/components/SortedProductSection.vue'
import { captureMessage } from '@sentry/browser'

import './main.entry.scss'
import { BQ_EVENT_NAMES, raksulBQEventTracker } from '@/common/utils'
import { BQImpressionData } from './types'
import { initFavoriteBtn, initFavoriteBtnPopup } from '@/common/utils/favorite'

const maxQuantityPrice: MaxQuantityPrice = getJsonData(data.maxQuantityPrice)
const initSidebarApp = () => {
  const mountEl = document.querySelector(app.sidebarMountEl)

  if (!mountEl) return

  new Vue({
    render: h =>
      h(SidebarApp, {
        props: { sharedStore: store, maxQuantityPrice }
      })
  }).$mount(mountEl)
}

const initSearchFilter = () => {
  if (window.innerWidth <= 1024) {
    const mountEl = document.querySelector(app.searchFilterMountEl)
    if (!mountEl) return

    const categoryId = mountEl.getAttribute('data-category-id')

    if (!categoryId) {
      captureMessage('Category ID not found')
      return
    }
    new Vue({
      render: h => h(SearchFilterCtrl, {
        props: { sharedStore: store, categoryId, maxQuantityPrice }
      })
    }).$mount(mountEl)
  }
}

const initApp = () => {
  const mountEl = document.querySelector(app.appMountEl)

  if (!mountEl) return

  const categoryId = Number(mountEl.getAttribute('data-category-id'))

  if (!categoryId) {
    captureMessage('Category ID not found')
    return
  }

  Vue.filter('formatCurrencyJP', formatCurrencyJP)
  new Vue({
    render: h =>
      h(App, {
        props: { sharedStore: store, categoryId, maxQuantityPrice }
      })
  }).$mount(mountEl)
}

const initCategories = () => {
  const mountEl = document.querySelector(app.allCategoriesMountEl)
  if (!mountEl) return
  new Vue({
    render: h => h(Categories, {
      props: {
        productCategories:
          getJsonData('#applicationData').product_categories || undefined
      }
    })
  }).$mount(mountEl)
}

const initFacets = () => {
  const mountEl = document.querySelector(app.facetsMountEl)
  if (!mountEl) return

  const jsonRootCategory = getJsonData(data.rootCategory)
  const categoryId = jsonRootCategory?.id || undefined
  new Vue({
    render: h => h(FacetsLink, {
      props: {
        categoryId
      }
    })
  }).$mount(mountEl)
}

const initSortedProductList = () => {
  const mountEl = document.querySelector(app.sortedProductListMountEl)

  if (!mountEl) return

  Vue.filter('formatCurrencyJP', formatCurrencyJP)

  const jsonRootCategory = getJsonData(data.rootCategory)
  const categoryId = jsonRootCategory?.id || undefined

  new Vue({
    render: h => h(SortedProductSection, {
      props: {
        categoryId
      }
    })
  }).$mount(mountEl)
}

const initTracking = () => {
  let impressionDataArray: BQImpressionData[] = []
  const productPerRow = 4

  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry: any) => {
      const productIndex = entry.target.dataset.productIndex
      const sectionRowNumber = Math.floor((Number(productIndex) - 1) / productPerRow) + 1
      if (entry.isIntersecting) {
        const impressionData = {
          productId: entry.target.dataset.productId,
          sectionName: entry.target.dataset.sectionName,
          sectionRowNumber: sectionRowNumber.toString()
        }
        impressionDataArray.push(impressionData)
        trigger()
        observer.unobserve(entry.target)
      }
    })
  }, {
    root: null,
    threshold: 1
  })

  const trackedElements = document.querySelectorAll('.productItem-image-container')
  trackedElements.forEach(div => {
    observer.observe(div)
  })

  const sendImpressionData = () => {
    raksulBQEventTracker({
      eventName: BQ_EVENT_NAMES.VIEW_PRODUCT_CATEGORY,
      data: {
        viewedProducts: JSON.stringify(impressionDataArray)
      }
    })
    impressionDataArray = []
  }

  const trigger = () => {
    setTimeout(() => {
      if (impressionDataArray.length === 0) return
      sendImpressionData()
    }, 2000)
  }
}


initApp()
initSearchFilter()
initSidebarApp()
initCategories()
// initFacets()
// initSortedProductList()
initTracking()
initFavoriteBtn(app.favoriteButtonMountEl)
initFavoriteBtnPopup(app.favoriteButtonPopupMountEl)
